import React from 'react';
import footerLogo from "../../assets/images/footerLogo.png";
import "./Footer.css";
import { IoIosSend } from "react-icons/io";
import { MdOutlineEmail } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

export const Footer = () => {
  return (
   <>
    <div className='footerContainer'>
      <div className='container'>
        <div className='footerGrid'>
          <div className='footerList'>
            <a href='/home'><span>Home</span></a>
            <span>Hero Section</span>
            <span>Features</span>
            <span>Properties</span>
            <span>Testimonials</span>

          </div>
          <div className='footerList'>
            <a href='/about'><span>About Us</span></a>
            <span>Our Story</span>
            <span>Our Works</span>
            <span>How It Works</span>
            <span>Our Clients</span>

          </div>
           <div className='footerList'>
            <a href='/contact'><span>Contact Us</span></a>
            <span>Contact Form</span>
            <span>Our Offices</span>
          
        

          </div>
           <div className='footerList'>
            <div><img src={footerLogo}/></div>
            <div className='footerInput'><button style={{cursor:'none'}}><MdOutlineEmail /></button><input type="text" placeholder='Enter Your Email'/><button><IoIosSend /></button></div>
           
        

          </div>
        </div>

      </div>

    </div>
    <div className='copyRightContainer'>
     <div className='container'>
       <div className='copySubContainer'>
        <div className='copyGrid'>
          <div>@2025 SnapBid. All Rights Reserved to Lagran.in</div>
          <div>Terms & Conditions</div>
          <div>Privacy Policy</div>
          <div>Refund Policy</div>
          
        </div>
        <div className='copyIcons'>
          <span><FaFacebookF /></span>
        <span><FaLinkedin /></span>
        <span><FaTwitter /></span>
        <span><FaYoutube /></span>
        </div>

      </div>
     </div>

    </div>
   </>
  )
}
